import { Form, Formik } from 'formik';
import React from 'react';
import { BiChevronLeft } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import Button from 'src/components/button';
import TextField from 'src/components/text-field';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Required'),
});

const ForgetPassword: React.FC<IProps> = ({}) => {
  const [errorMsg, setErrorMsg] = React.useState('');
  const navigate = useNavigate();

  const initVal = {
    email: '',
  };

  const hanldeForgetPassword = async (val: { email: string }) => {
    try {
      const { data } = await Service.post('/employees/forgotPasswordOtp', val);
      navigate('/otp', {
        state: {
          email: val.email,
          forgetPassword: true,
        },
      });
      toastAlert('success', data?.message ?? 'Something went wrong.');
    } catch (err: any) {
      setErrorMsg(err?.response?.data?.message);
    }
  };

  return (
    <div className="max-h-screen ">
      <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
        <div
          className="mt-[150px] w-10 h-10 rounded-[50%] bg-primary-light"
          onClick={() => navigate('/login')}
        >
          <BiChevronLeft size={'40px'} style={{ color: '#4062FF' }} />
        </div>
        <div className="my-6">
          <h1 className="text-4xl font-semibold mb-5">Forgot Password?</h1>
          <p className="text-light-grey text-base">
            Don’t worry, enter your email address and we’ll send you a link to
            reset your password.
          </p>

          <Formik
            initialValues={initVal}
            onSubmit={hanldeForgetPassword}
            validateOnMount
            validationSchema={FORM_VALIDATION}
          >
            {({ isSubmitting, isValid }) => (
              <Form className="mt-10">
                {errorMsg && (
                  <p className="text-center text-warning font-semibold">
                    {errorMsg}
                  </p>
                )}
                <TextField
                  label="Email / Phone Number"
                  name="email"
                  placeholder="Enter your email address"
                />
                {/* <div className="relative">
              <TextField
                label="Password"
                name="password"
                type={`${!passwordVisibleSwitch ? 'password' : 'text'}`}
              />
              {!passwordVisibleSwitch ? (
                <AiOutlineEye
                  className="absolute top-9 right-4 "
                  onClick={handlePasswordVisible}
                  size={20}
                  color="#4062FF"
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="absolute top-9 right-4 "
                  onClick={handlePasswordVisible}
                  size={20}
                  color="#4062FF"
                />
              )}
            </div> */}
                {/* <p className="text-primary text-xs font-semibold text-end cursor-pointer">
              Forget Password?
            </p> */}
                <Button
                  text="Send Link"
                  type="submit"
                  variant="primary"
                  className="w-full mt-5"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ForgetPassword);
